import { z } from 'zod';

import { BooleanParamSchema } from '../../common/boolean-param/boolean-param';
import { makeListQuery } from '../../common/list-query/list-query';

/**
 * The whitelisted filters of the course list (N7).
 *
 * `search` matches the **caller's locale** title, unlike the template list which
 * searches a stable key: a course has no operator-facing key, and the title is
 * what a staff member is looking at when they type.
 *
 * `isActive` is a strict `'true'|'false'` transform, never `z.coerce.boolean()`,
 * which reads `'false'` as `true` (N7).
 */
export const CoursesListQuerySchema = makeListQuery({
  isActive: BooleanParamSchema.optional(),
  search: z.string().trim().min(1).max(160).optional(),
});

export type CoursesListQuery = z.infer<typeof CoursesListQuerySchema>;
